import { get } from 'lodash';

import { BUSINESS_STRUCTURE, FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { CompanyEntityIndex, CompanyOwner, EmploymentEntityIndex } from '@funnels/types';

import { DropdownField } from '../../Fields';

const OPTIONS = [
  { label: 'Company', value: BUSINESS_STRUCTURE.COMPANY },
  { label: 'Partnership', value: BUSINESS_STRUCTURE.PARTNERSHIP },
  { label: 'Sole trader', value: BUSINESS_STRUCTURE.SOLE_TRADER },
  { label: 'Trust', value: BUSINESS_STRUCTURE.TRUST },
];

interface BusinessStructureProps extends CompanyEntityIndex, EmploymentEntityIndex {
  isDisabled?: boolean;
  isOptional?: boolean;
}

export const BusinessStructure = (props: BusinessStructureProps) => {
  const { companyIndex, employmentIndex, ...rest } = props;
  const [formValues, setFormValue] = useFormValues();
  const applicantId = get(formValues, FIELD_PATHS.EMPLOYMENT_APPLICANT_ID(employmentIndex));

  const handleChange = (values: string[]) => {
    if (values[0] === BUSINESS_STRUCTURE.SOLE_TRADER) {
      setFormValue(FIELD_PATHS.COMPANY_OWNERS(companyIndex), [
        {
          applicantId,
          percentOwned: 1,
        },
      ] as CompanyOwner[]);
    }
  };

  return (
    <DropdownField
      {...rest}
      // the usage of key is to prevent a bug from LUI Dropdown when resetting the value
      key={FIELD_PATHS.COMPANY_BUSINESS_STRUCTURE(companyIndex)}
      name={FIELD_PATHS.COMPANY_BUSINESS_STRUCTURE(companyIndex)}
      label="Business structure"
      options={OPTIONS}
      onChange={handleChange}
    />
  );
};
